import { useSelector } from 'react-redux'

export const useSelectedFinanceCompanyUUID = () => {
	const selectedFinanceCompanyUUID = useSelector(
		({ app }: any) => app?.selectedFinanceCompanyUUID as string,
	)

	return selectedFinanceCompanyUUID
}
